var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-col",
    {
      class: { "none-display": !_vm.getItemLabel },
      attrs: { span: _vm.item.config.span },
    },
    [
      _c(
        "el-form-item",
        {
          staticClass: "project_item",
          attrs: {
            "label-width": _vm.item.config.labelWidth
              ? _vm.item.config.labelWidth + "px"
              : null,
            prop: _vm.item.vModel,
          },
          scopedSlots: _vm._u([
            {
              key: "label",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "flex-column",
                      staticStyle: { width: "100%" },
                    },
                    [
                      _c("div", { staticClass: "label_box" }, [
                        _vm.item.config.required
                          ? _c("span", { staticClass: "required_icon" })
                          : _vm._e(),
                        _c("div", [
                          _c("div", {
                            staticStyle: { width: "100%" },
                            domProps: { innerHTML: _vm._s(_vm.getItemLabel) },
                          }),
                        ]),
                      ]),
                      _vm.item.config.description
                        ? _c(
                            "span",
                            {
                              class: [
                                "desc_text",
                                { "pl-10": _vm.item.config.required },
                              ],
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.item.config.description || "问题描述"
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm.componentList.includes(_vm.item.typeId)
            ? [
                _c(_vm.getComponentName(_vm.item), {
                  tag: "component",
                  attrs: {
                    item: _vm.item,
                    models: _vm.models,
                    pageShowMore: _vm.pageShowMore,
                  },
                  model: {
                    value: _vm.dataModel,
                    callback: function ($$v) {
                      _vm.dataModel = $$v
                    },
                    expression: "dataModel",
                  },
                }),
              ]
            : ["RADIO", "CHECKBOX", "NPS"].includes(_vm.item.typeId)
            ? [
                _c(_vm.getComponentName(_vm.item), {
                  tag: "component",
                  attrs: { item: _vm.item, models: _vm.models },
                  on: {
                    "update:models": function ($event) {
                      _vm.models = $event
                    },
                    "other-input-change": _vm.otherInputChange,
                  },
                  model: {
                    value: _vm.dataModel,
                    callback: function ($$v) {
                      _vm.dataModel = $$v
                    },
                    expression: "dataModel",
                  },
                }),
              ]
            : ["OCR"].includes(_vm.item.typeId)
            ? [
                _c(_vm.getComponentName(_vm.item), {
                  tag: "component",
                  attrs: { item: _vm.item, models: _vm.models },
                  on: {
                    "ocr-success": function (val) {
                      _vm.$emit("ocr-success", val)
                    },
                  },
                  model: {
                    value: _vm.dataModel,
                    callback: function ($$v) {
                      _vm.dataModel = $$v
                    },
                    expression: "dataModel",
                  },
                }),
              ]
            : ["PAGINATION"].includes(_vm.item.typeId)
            ? [
                _c(
                  _vm.getComponentName(_vm.item),
                  _vm._b(
                    {
                      tag: "component",
                      on: {
                        next: function (page) {
                          _vm.$emit("next", page)
                        },
                        prev: function (page) {
                          _vm.$emit("prev", page)
                        },
                      },
                    },
                    "component",
                    Object.assign({}, _vm.item),
                    false
                  )
                ),
              ]
            : [
                _c(
                  _vm.getComponentName(_vm.item),
                  _vm._b(
                    {
                      tag: "component",
                      attrs: { item: _vm.item },
                      model: {
                        value: _vm.dataModel,
                        callback: function ($$v) {
                          _vm.dataModel = $$v
                        },
                        expression: "dataModel",
                      },
                    },
                    "component",
                    Object.assign({}, _vm.item),
                    false
                  )
                ),
              ],
        ],
        2
      ),
      !_vm.pageShowMore && _vm.item.currPageNum < _vm.item.totalPageNum
        ? [
            _c(
              "div",
              { staticClass: "flex-center" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "submit-btn-form-item btn-fixed",
                    style: _vm.getSubmitBtnStyle,
                    attrs: { type: "primary" },
                    on: {
                      click: function () {
                        _vm.$emit("next", _vm.item.currPageNum)
                      },
                    },
                  },
                  [_vm._v("下一题")]
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }